<template>
  <div class="testHome">
    <navBarNoLab :onIndex="0"></navBarNoLab>
    <div class="testHome_container">
      <div class="banner">
        <div class="bannerfont">
          <img src="./images/banner_font.png" width="850" alt="">
        </div>
      </div>
      <div class="labelCont">
          <div class="labelItem" v-for="(item,index) in bannerInfo.contListDataes" :key="index">
              <div class="vdplay" @click="handleVideo(item.vidUrl)">
                <img :src="item.image" width="120px" alt="">
                <img class="play" width="20px" src="./images/icon_play.png" alt="">
              </div>
              <div>
                <p class="tit">{{item.title}}</p>
                <p class="dest">{{item.desc}}</p>
              </div>
          </div>
        </div>
        <div class="objectList" v-if="itemData && itemData.length > 0">
          <div class="title">热门行业真项目，飞速体验</div>
          <div class="desc"></div>
          <div class="objList" >
            <div class="items" v-for="(value, index) in itemData" :key="index" @click="goDetails(value)">
                <div class="divImg">
                    <img src="./../../../../assets/cover.jpg" v-if="value.logoImage === null || value.logoImage === ''" />
                    <img v-lazy="{ src: value.logoImage.url, loading: require('./../../../../assets/coverpic.jpg'), }" v-else />
                </div>
                <div class="info">
                  <div class="infoTit"><span>{{ value.name }}</span><span>{{ value.trade.name }}</span></div>
                  <div>{{ value.indexPageDescription }}</div>
                </div>
            </div>
          </div>
        </div>
        <div class="screenA" :class="{mdShowA: tgshow.some(it => it == 'A')}" id="scrollTg1">
            <TestHomeTitle title="职场老手教你如何分辨「真假项目」" subTitle="能够分辨，才能学到真项目，才能找到好工作"></TestHomeTitle>
            <div class="content">
                <div class="leftCont">
                  <div class="titCont">
                      <img src="./images/logo_wit.png" width="240px" alt="">
                  </div>
                  <div class="rowCont">
                    <div class="rowList"  v-for="(item, index) in contrastData.leftCont" :key="index">  
                      <div class="title">{{item.title}}</div>
                      <div class="desc">{{item.desc}}</div>
                      <div class="itemIcon">
                        <p><img :src="item.icon" width="26px" alt=""></p>
                        <p>{{item.label}}</p>
                      </div>
                    </div>
                  </div>
                  </div>
                <div>
                <div class="ritCont">
                    <div class="titCont">
                        部分机构
                    </div>
                    <div class="rowCont">
                      <div class="rowList" v-for="(item, index) in contrastData.rightCont" :key="index">
                        <div class="title">{{item.title}}</div>
                        <div class="desc">{{item.desc}}</div>
                      </div>
                    </div>
                  </div>
                </div>
                
            </div>
        </div>
        <div class="screenB" :class="{mdShow: tgshow.some(it => it == 'B')}" id="scrollTg2">
          <TestHomeTitle title="真实战，助力工作飞速上手" subTitle="真实的业务需求分析、真实生产中产生的开发Bug，企业完整的开发测试上线流程，飞速助你完成菜鸟到精英的蜕变"></TestHomeTitle>
          <div class="content">
            <div class="imgCont">
              <div class="font">测试148期学员  实战项目周会</div>
              <img src="./images/img_sb.jpg" width="100%" alt="">
            </div>
            <div class="infoCont">
              <div class="item" v-for='(item, index) in screenBData' :key="index">
                <div class="tit">
                  <img :src="item.icon" width="25px" alt="">
                  {{item.name}}  
                </div>
                <div class="list" v-for='(it, ind) in item.listData' :key="ind"> {{it}} </div>
              </div>
            </div>
          </div>
        </div>
        <div class="screenC" :class="{mdShow: tgshow.some(it => it == 'C')}" id="scrollTg3">
          <TestHomeTitle title="项目课程 学习路线图" subTitle="从小白到大牛，标准的学习方法，清晰的上升路线"></TestHomeTitle>
          <div class="content">
            <img src="./images/img_modC.png" width="1427px" alt="">
            <div class="imgArea">
              <div v-for="(item, ind) in leanLineData" :key="ind" :class="`area${ind+1}`">
                <div class="hoverBox">
                  <div class="title">{{item.title}}</div>
                  <div class="list" v-for="(it, ind) in item.list" :key="ind">{{it}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>      
        <div class="screenD" :class="{mdShow: tgshow.some(it => it == 'D')}" id="scrollTg4">
          <div class="titleCont">
            <TestHomeTitle title="项目课程 能力培养体系" subTitle="项目课程以企业人才需求为导向、以能力培养为目标进行课程体系设计，实现学员综合能力培养"></TestHomeTitle>
          </div>
          <div class="content">
            <div class="topLab">
              <span :class="{labA:true, act:scDstart == 1}" @click="() => scDstart = 1">能力图谱</span>
              <span :class="{labB:true, act:scDstart == 2}" @click="() => scDstart = 2">测试工具</span>
            </div>
            <div class="minImg">
              <img v-show="scDstart == 1" src="./images/img_modD.png" alt="Planets" width="1439px">
              <div class="imgArea2" v-show="scDstart == 1">
              <div v-for="(item, ind) in abilityMapData" :key="ind" :class="`area${ind+1}`">
                <div class="hoverBox">
                  <div class="list" v-for="(it, ind) in item.list" :key="ind">{{it}}</div>
                </div>
              </div>
            </div>
              <img v-show="scDstart == 2" src="./images/img_modD2.png" style="max-width: 1239px;top:30px;position:relative" alt="">
            </div>
          </div>
        </div>  
        <div class="screenE" :class="{mdShow: tgshow.some(it => it == 'E')}" id="scrollTg5">
          <TestHomeTitle title="助你“高新”就业，是我们的目标！" subTitle=""></TestHomeTitle>
          <div class="content">
            <img src="./images/img_modE.png" width="1126px" alt="">
          </div>
        </div>  
    </div>
    <bottom-widge></bottom-widge>
    <MenuAdd ref="editMenu"></MenuAdd>
  </div>
</template>

<script>
import navBarNoLab from "./../../../components/navBarNoLab";
import bottomWidge from "./../../../components/bottomWidge";
import { Contents } from "../../../../gqlapi/Contents.js";
import MenuAdd from "./../../../components/video";
import  TestHomeTitle from "./components/TestHomeTitle";
export default {
  name: "layout",
  components: {
    navBarNoLab,
    bottomWidge,
    TestHomeTitle,
    MenuAdd
  },
  data() {
    return {
      tgshow:[],
      bannerInfo:{
        contListDataes:[
          {
            image:require('./images/bannerLab1.png'),
            vidUrl: 'https://v.itheima.net/pip-test/CwQd8y.mp4',
            title:'为什么需要测试工程师？',
            desc:'“测试”是企业开发不可缺少的一个环节'
          },
          {
            image:require('./images/bannerLab3.png'),
            vidUrl: 'https://v.itheima.net/pip-test/XzLZ25.mp4',
            title:'测试工程师的就业前景？',
            desc:'入门快、不受性别、基础、专业等限制'
          }
        ]
      },
      itemData:null,
      scDstart: 1,
      contrastData:{
        leftCont:[
          {title:'专职团队打造，呈现企业上线级别', desc:'亿元级投入，专职团队为教学而研发，所学项目内容大部分就是未来工作后需要用的内容', icon: require('./images/icon_yf.png'), label:'研发'},
          {title:'企业真实业务需求，研发过程产出真Bug', desc:'产品经理团队提供完整的业务方案，开发团队进行开发，并将实开发中产生的真实Bug投入教学', icon: require('./images/icon_yw.png'), label:'业务'},
          {title:'主打“自动化测试”，适应市场招聘要求', desc:'知识点讲解深入，2/3课程主讲解自动化测结合学员反馈，按周更新优化课程，更适应学员吸收', icon: require('./images/icon_js.png'), label:'技术'},
          {title:'课程设计精心打磨，理论+实战Plus', desc:'注重“项目实战”，让学员将所学技能融会贯通课程设计，既有“微实战”还有“单独实战阶段”', icon: require('./images/icon_sz.png'), label:'实战'},
          {title:'技能护体，打怪升级，为就业护航', desc:'学过真项目、做过真实战、实际工作上手快与真实企业环境无缝衔接，愈多就业机会，愈多选择', icon: require('./images/icon_jy.png'), label:'就业'},
        ],
        rightCont:[
          {title:'Demo级案例，与企业真实业务脱节', desc:'开源的小案例，无法呈现企业真实业务场景，不考虑教学需求，有啥用啥'},
          {title:'编造的业务，改造出Bug', desc:'标题党，列举n多项目，没有实际业务需求，教学项目Bug完全靠臆想，脱离真实生产环境'},
          {title:'市场主流技能“自动化测试”课程不足1/3', desc:'注重工具学习和功能测试，自动化测试相关教学时长不足1/3课程设计知识点堆积，“贪多嚼不烂”，代码讲解浅显'},
          {title:'课程结构设计，重理论轻实战', desc:'没有单独设置“实战”阶段课程大多只有“课后练习”式的项目微实战'},
          {title:'面试心里没底，求职屡屡碰壁', desc:'技术掌握浅显，缺少不依赖他人的实战经验，面试一问很可能就露怯求职屡屡碰壁， 结业即失业'},]
      },
      screenBData:[
        {
          icon: require('./images/icon_sz.png'),
          name: '什么是项目实战？',
          listData: ['跟着老师进行团队项目研发','模拟企业开发环境、工作场景、工作流程','分析需求、不依赖他人编写代码、修改Bug','进行项目实战答辩']
        },
        {
          icon: require('./images/icon_xx.png'),
          name: '通过项目实战你能学到什么？',
          listData: ['代码编写、代码提交等实操技能','ONES等开发工具的实用','不依赖他人思考并解决技术问题','需求沟通、组织协调、团队协作']
        },
        {
          icon: require('./images/icon_jy.png'),
          name: '项目实战对于就业的价值是什么？',
          listData: ['学以致用，加强编码能力','转化角色，摆脱小白标签，飞速上手工作','加强团队沟通、解决工作难题的能力','项目答辩，加强表达能力，从容应对面试']
        }
      ],
      leanLineData:[
        {title: '黑马头条', list: ['了解软件测试行业','掌握计算机相关基础知识','掌握Web前端CSS、HTML、JS基础','掌握Linux系统命令使用','掌握MySql、Redis数据库的使用']},
        {title: 'TPshop商城', list: ['掌握测试的基本概念和测试常见分类','掌握黑盒测试用例设计方法','掌握缺陷报告的编写','熟悉测试管理工具禅道和JIRA的使用','掌握项目测试流程','掌握Web项目功能测试分析和用例编写','熟悉测试计划，方案、报告的内容','掌握功能测试与数据库的关系','掌握Fiddler工具的使用']},
        {title: 'Ego微商小程序', list: ['掌握微信小程序的测试特点','掌握项目测试流程测试工作','掌握Python+Requests库框架搭建和使用']},
        {title: '人力资源管理系统', list: ['掌握接口及接口测试相关概念','掌握使用Postman进行接口测试','掌握数据库的基本操作和事务操作','掌握Python+Requests库使用及脚本封装','掌握接口测试框架的设计和封装','掌握使用持续集成工具管理接口测试脚本','掌握实际项目中灵活运用接口测试的相关技术']},
        {title: '黑马头条', list: ['熟练搭建Web自动化和移动自动化测试环境','掌握Web自动化测试流程和脚本编写','掌握移动端元素定位方法、操作和手势操作','掌握ADB工具的使用','掌握PO模式的设计思想，并对页面进行封装','掌握数据驱动的实现方式','掌握日志的相关概念，以及日志的收集处理','掌握项目中灵活运用自动化的相关技术']},
        {title: '轻商城', list: ['能够熟练搭建性能测试环境','掌握性能测试基础理论','掌握JMeter常用组件使用','掌握JMeter编写和录制性能测试脚本','掌握基于JMeter实现单一和混合场景搭建','掌握事务、逻辑控制器在性能测试场景的应用','掌握JMeter常用性能插件进行图表分析','掌握Linux服务型性能监控方法和指标','掌握数据库监控和调优的常见方法']},
        {title: '无偿赠送：', list: ['数据结构、单元测试、Shell','可掌握能力：','熟悉算法的时间复杂度和空间复杂度','掌握常见数据结构的使用','掌握常见排序算法的使用','掌握单元测试的方法和实现','掌握Shell编程常用表达式和流程控制语句']},
        {title: '黑马金融理财', list: ['掌握金融项目的测试流程','掌握金融项目功能实现及全流程功能测试','掌握Python+Requests库框架搭建和使用','掌握接口测试痛点解决方案']},
        {title: '职场大牛：', list: ['传智教育私有资源','技术私享会：对话出名的企业大咖，前线技术抢先看','IT训练营：匹配个人职业，冲破职业瓶颈','行家赋能：行业人士，前线技术分享','出名的名企直通车：助力迈向职场新阶段']},
      ],
      abilityMapData:[
        {title:'接口测试',list:['接口基本概念','常见的请求方式，如GET,POST','接口文档学习', '接口测试用例编写','接口测试工具使用，如Postman、JMeter']},
        {title:'性能测试',list:['性能测试基础','性能测试流程设计','性能测试工具使用','性能测试报告输出']},
        {title:'数据库',list:['数据库基本概念','操作MySql数据库','数据库客户端使用，如Navicat']},
        {title:'其他',list:['代码版本提交，如Git','持续集成项目， 如Jenkins']},
        {title:'测试基础理论',list:['软件测试流程','测试计划编写','测试用例编写','缺陷管理','测试用例执行','测试报告编写','Web测试','APP、小程序测试']},
        {title:'Linux',list:['Linux系统基础知识','常见Linux命令','编写简单的Shell脚本','Linux环境日志查询','远程终端工具使用，如Xshell']},
        {title:'自动化测试',list:['Python语言','前端基础语言，如CSS，HTML，JS','Web自动化测试，如Selenium','App自动化测试， 如Appium，Monkey','自动化测试框架搭建']},
      ],
      baseInfo:{
        baseInfoTitle1: '',
        baseInfoTitle2: '',
        baseInfoDesc1: '',
        baseInfoDesc2: '',
        pVideoUrl: '',
        videoLogoImage: ''
      },
    };
  },
  created() {
    this.getList(this.listId);
  },
  mounted() {
    window.addEventListener("scroll", this.scrollHandle);
  },
  methods: {
    // 点击跳转到项目详情 
    goDetails(item) {
      if(item.url != null){
        window.open(item.url, "_blank");
      }
      if(item.router != null) {
        window.open(item.router, "_blank");
      }
      // window.sessionStorage.setItem("detailsId", String(item.id));
      // this.$trackEvent(item.name, "点击项目", item.name);
      
    },
    // 滚动浮窗
    scrollHandle(){
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        // let magTop = document.querySelector('#scrollTag');
        let aimsId1 = document.querySelector('#scrollTg1');
        let aimsId2 = document.querySelector('#scrollTg2');
        let aimsId3 = document.querySelector('#scrollTg3');
        let aimsId4 = document.querySelector('#scrollTg4');
        let aimsId5 = document.querySelector('#scrollTg5');
        let baseTag = -700
        // console.log(aimsId1.offsetTop)
        if( scrollTop >= aimsId1.offsetTop + baseTag && scrollTop <= aimsId2.offsetTop + baseTag){
          this.tgshow.push('A')
        } else if (scrollTop >= aimsId2.offsetTop + baseTag && scrollTop < aimsId3.offsetTop + baseTag){
          this.tgshow.push('B')
        } else if (scrollTop >= aimsId3.offsetTop + baseTag && scrollTop < aimsId4.offsetTop + baseTag){
          this.tgshow.push('C')
        } else if (scrollTop >= aimsId4.offsetTop + baseTag && scrollTop < aimsId5.offsetTop + baseTag){
          this.tgshow.push('D')
        } else if (scrollTop >= aimsId5.offsetTop + baseTag){
          this.tgshow.push('E')
        }
    },
    // 获取 项目列表数据
    getList() {
      // this.$apollo
      //   .query({
      //     query: Contents,
      //     variables: {
      //       subjectID: 1,
      //       isPublish: true,
      //     },
      //   })
      this.$axios.post('/api',{
          operationName: "Contents",
          variables:{
              subjectID: 4,
              isPublish: true,
          },
          query: Contents
      }).then((res) => {
        this.itemData = res.data.data.pContents;
      })
      .catch(() => {});
    },
    handleVideo(url,e) {
      this.baseInfo.pVideoUrl = url
      window.event ? (window.event.cancelBubble = true) : e.stopPropagation();
      this.$refs.editMenu.dialogFormV(this.baseInfo);
    },
  },
};
</script>
<style src='./style.scss' rel="stylesheet/scss" lang="scss" scoped></style>